import React from "react";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useLoggedInUser } from "../../api/user-auths/login";
import Loading from "../../utils/Loading";

export const PersonalInformation = () => {
  const user = useLoggedInUser();

  if (user.isSuccess) {
    return (
      <IgPaper sx={{ height: "220px" }}>
        <Grid container rowSpacing={1} direction={"column"}>
          <Grid item xs={12}>
            <IgTypography fontWeight={"fontWeightMedium"} variant="h3">
              Personal Settings
            </IgTypography>
          </Grid>
          {user.data.user.email && (
            <>
              <Grid container direction={"row"} item xs={12}>
                <IgTypography sx={{ marginRight: "20px", fontWeight: "bold" }}>
                  Name:
                </IgTypography>
                <IgTypography>
                  {user.data.user.firstName} {user.data.user.lastName}
                </IgTypography>
              </Grid>
              <Grid container direction={"row"} item xs>
                <IgTypography sx={{ marginRight: "20px", fontWeight: "bold" }}>
                  Email:
                </IgTypography>
                <IgTypography> {user.data.user.email}</IgTypography>
              </Grid>
            </>
          )}
        </Grid>
      </IgPaper>
    );
  }
  return <Loading />;
};
